// src/routes/AdminRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ResponsiveDrawer from "../components/sidebar";
import Dashboard from "../screens/admin/dashboard";
import Projects from "../screens/admin/projects";
import Groups from "../screens/admin/groups";
import Users from "../screens/admin/users";
import ViewTimeSheet from "../screens/admin/viewTimeSheet/container/ViewTimeSheet";
// import ViewTimeSheet from "../screens/admin/users/viewTimeSheet";

import TimeReport from "../screens/admin/timeReport/TimeReport";
import WeeklyTimeReport from "../screens/admin/weeklyTimeReport/WeeklyTimeReport";
import ViewSingleTimeSheet from "../screens/admin/weeklyTimeReport/ViewSingleTimeSheet";
import Clients from "../screens/admin/clients";
import AddClient from "../screens/admin/clients/add";
import ClientDetails from "../screens/admin/clients/details";
import AddProject from "../screens/admin/projects/add";
import Invoices from "../screens/admin/invoices";
import AddInvoice from "../screens/admin/invoices/add";


function AdminsRoutes() {
  return (
    <ResponsiveDrawer>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectId/edit" element={<AddProject />} />
        <Route path="/projects/add" element={<AddProject />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/users" element={<Users />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:clientId" element={<ClientDetails />} />
        <Route path="/clients/add" element={<AddClient />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoices/add" element={<AddInvoice />} />
        <Route path="/invoices/:invoiceId/edit" element={<AddInvoice />} />
        <Route path="/view-time-sheet/:userId" element={<ViewTimeSheet />} />
        <Route path="/time-report" element={<TimeReport />} />
        <Route path="/weekly-time-report" element={<WeeklyTimeReport />} />
        <Route path="/weekly-time-sheet/:userId" element={<ViewSingleTimeSheet />} />
      </Routes>
    </ResponsiveDrawer>
  );
}

export default AdminsRoutes;
